import { useState } from 'react'
import { Grid, Typography, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Sheet, ActionBar } from '../../components'

const parse = value => {
    const n = Number(String(value).trim())
    return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null
}

export default function FoundItSheet({ open, onClose, onConfirm }) {
    const { t } = useTranslation()
    const [newark, setNewark] = useState('')
    const [longbranch, setLongbranch] = useState('')

    const nq = parse(newark)
    const lq = parse(longbranch)
    const valid = nq != null && lq != null && (nq + lq) > 0

    const close = () => { setNewark(''); setLongbranch(''); onClose?.() }

    const confirm = () => {
        if (!valid) return
        setNewark(''); setLongbranch('')
        onConfirm?.({ newark: nq, longbranch: lq })
    }

    return (
        <Sheet
            open={open}
            onClose={close}
            actions={
                <ActionBar
                    cancel={{ label: t('common.cancel'), onClick: close }}
                    confirm={{ label: t('common.save'), onClick: confirm, disabled: !valid }}
                />
            }
        >
            <Typography variant='h6' textAlign='center'>{t('inventoryCheck.review.foundHeading')}</Typography>
            <Typography textAlign='center' color='text.secondary' sx={{ marginBottom: '1rem' }}>
                {t('inventoryCheck.review.foundNote')}
            </Typography>

            <Grid container direction='column' sx={{ gap: '1rem' }}>
                <TextField
                    id='found-newark'
                    label={t('inventoryCheck.review.foundAtNewark')}
                    value={newark}
                    onChange={event => setNewark(event.target.value)}
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                    autoFocus
                />
                <TextField
                    id='found-longbranch'
                    label={t('inventoryCheck.review.foundAtLongBranch')}
                    value={longbranch}
                    onChange={event => setLongbranch(event.target.value)}
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                />
            </Grid>

            {!valid && (newark !== '' || longbranch !== '') && (
                <Typography color='warning.main' textAlign='center' sx={{ marginTop: '.75rem' }}>
                    {t('inventoryCheck.review.foundNeedsOne')}
                </Typography>
            )}
        </Sheet>
    )
}
